const CONFIG = {
  BASE_URL: process.env.BASE_URL,
  BASE_IMAGE_URL: process.env.BASE_IMAGE_URL,
  CACHE_NAME: 'RestaurantApps',
  DEFAULT_LANGUAGE: 'en-us',
  DATABASE_NAME: 'restaurant-apps-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};
export default CONFIG;
